module.exports = __webpack_public_path__ + "img/SignInImage@2x.9e9cdffa.png";